import { defineStore } from 'pinia'
import upperFirst from 'lodash/upperFirst'
import toLower from 'lodash/toLower'
import i18n from '@/i18n'
import { LANGS, LS_LANGUAGE_KEY } from './languages'

export const useLanguageStore = defineStore({
  id: 'language',
  state: () => ({
    language: localStorage.getItem(LS_LANGUAGE_KEY) || LANGS.FR.id
  }),
  actions: {
    async setLanguage(wantedLanguage) {
      const lang = toLower(wantedLanguage)
      try {
        if (lang) {
          i18n.global.locale.value = lang
          window.localStorage.setItem(LS_LANGUAGE_KEY, lang)
          this.language = lang
        }
      } catch (e) {
        console.log(e)
      }
    },
    async setFr() {
      await this.setLanguage(LANGS.FR.id)
    },
    async setEn() {
      await this.setLanguage(LANGS.EN.id)
    }
  },
  getters: {
    invertLanguage: (state) => (state.language === LANGS.FR.id ? LANGS.EN.id : LANGS.FR.id),
    upperLanguage: (state): string => upperFirst(state.language),
    isFr: (state): boolean => state.language === LANGS.FR.id,
    isEn: (state): boolean => state.language === LANGS.EN.id,
    languageNameFr: (state): string =>
      state.language === LANGS.FR.id ? LANGS.FR.nameFr : LANGS.FR.nameEn,
    languageNameEn: (state): string =>
      state.language === LANGS.EN.id ? LANGS.EN.nameEn : LANGS.EN.nameFr
  }
})
